import React from "react";
import { useTranslation } from "react-i18next";
import Banner from "../components/Banner";
import Section1 from "../components/social-responsibility/Section1";
import Section2 from "../components/social-responsibility/Section2";
import Section3 from "../components/social-responsibility/Section3";
import Section4 from "../components/social-responsibility/Section4";
import Section5 from "../components/social-responsibility/Section5";
import Section6 from "../components/social-responsibility/Section6";
import Section7 from "../components/social-responsibility/Section7";

const SocialResponsibility = () => {
  const { t } = useTranslation();

  const bannerData = {
    title: t("socialResponsibility.title"),
    img: "/images/social-responsibility/sr.jpg",
  };

  return (
    <div className="pb-28">
      <div className="grid grid-cols-10 pb-28">
        <div className="col-start-2 md:col-start-2 col-span-8 ">
          <Banner bannerData={bannerData} />

          <Section1 />

          <Section2 />
        </div>
      </div>

      <Section3 />

      <Section4 />

{    /*  <Section5 /> */}

      <div>
        <Section6 />

      </div>
    </div>
  );
};

export default SocialResponsibility;
